<template>
  <div>
    <v-layout
      fill-height
      align-center
    >
      <h2 class="subheading font-weight-bold">
        Предложения
      </h2>
      <v-spacer />
      <v-btn
        :disabled="!canAdd"
        color="primary"
        small
        icon
        @click="showProposalDialog"
      >
        <v-icon>add</v-icon>
      </v-btn>
    </v-layout>
    <div class="pa-0">
      <v-data-table
        class="proposals-table"
        expand
        :headers-length="5"
        hide-headers
        :items="proposals"
        hide-actions
        item-key="title"
      >
        <template
          slot="items"
          slot-scope="props"
        >
          <tr @click="props.expanded = !props.expanded">
            <td>{{ props.item.title }}</td>
            <td>{{ props.item.version }}</td>
            <td>{{ props.item.date | dateTime }}</td>
            <td>{{ props.item.text | cropText(30) }}</td>
          </tr>
        </template>
        <template
          slot="expand"
          slot-scope="props"
        >
          <v-data-table
            :items="[props.item]"
            class="elevation-1"
            hide-actions
            hide-headers
          >
            <template
              slot="items"
              slot-scope="props"
            >
              <td>{{ props.item.text }}</td>
              <td class="text-xs-right">
                <v-btn
                  class="ma-0"
                  :disabled="!canAdd"
                  icon
                  small
                  right
                  @click="editProposals(props.item.id)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </template>
      </v-data-table>
    </div>
    <v-layout>
      <v-dialog
        v-model="proposalDialog"
        persistent
        width="500"
      >
        <v-card>
          <v-card-text>
            <v-form>
              <v-textarea
                v-model="proposal"
                label="Предложение"
              />

              <v-btn
                small
                color="primary"
                @click="addProposal"
              >
                Ок
              </v-btn>
              <v-btn
                small
                @click="closeProposalDialog"
              >
                Отмена
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import {
  createProposal,
  updateProposal,
} from "../../../backend/shipmentRequestsApi.js";

export default {
  props: ["id", "items", "disabled"],
  data() {
    return {
      proposalDialog: false,
      proposal: "",
      editProposalId: 0,
    };
  },
  computed: {
    proposals() {
      return this.items;
    },
    canAdd() {
      return !this.disabled;
    },
  },
  methods: {
    async addProposal() {
      if (this.editProposalId !== 0) {
        await updateProposal(this.id, this.editProposalId, this.proposal);
        this.closeProposalDialog();
        this.$emit("update");
      } else {
        await createProposal(this.id, this.proposal);
        this.closeProposalDialog();
        this.$emit("add");
      }
    },
    showProposalDialog() {
      if (this.canAdd) {
        this.proposalDialog = true;
      }
    },
    closeProposalDialog() {
      this.proposalDialog = false;
      this.proposal = "";
      this.editProposalId = 0;
    },
    editProposals(id) {
      const proposal = this.proposals.find(p => p.id === id);
      this.editProposalId = id;
      this.proposal = proposal.text;
      this.showProposalDialog();
    },
  },
};
</script>
